import React, {Component} from 'react';
import {Col, Form, FormGroup, FormControl, ControlLabel} from "react-bootstrap";
import {TopButtonAction} from "../../../../../componentsTopsa/buttons/TopButtons";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";
import TopDostepnosc from "../../../../../componentsTopsa/dostepnosc/TopDostepnosc";


export default class DefinicjaGodzinyStartowejForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasa: null,
            kalendarz: null,
            godzina: '',
            validatorMessages:[]
        };
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.onChnageKalendarz = this.onChnageKalendarz.bind(this)
        this.onChangeGodzina = this.onChangeGodzina.bind(this)
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }

    onChangeTrasa(e) {
        this.setState({trasa: e})
    }

    onChnageKalendarz(e) {
        this.setState({kalendarz: e})
    }

    onChangeGodzina(e) {
        this.setState({godzina: e.target.value})
    }

    optionRenderer(option) {
        return <div><span className={'label label-ebus-default'}>{option.kodTrasy}</span> {option.nazTr} <TopDostepnosc wartoscWarunek={0} wartosc={option.status} czyMarginesLewy={true}/></div>
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickSzukaj(){
        let poprawne = true; this.state.validatorMessages = [];

        if(!Boolean(this.state.trasa)){
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano trasy')
        }

        if(poprawne){
            this.setState({validatorMessages: []})
            this.props.handleClickSzukaj(
                {
                    trasa: this.state.trasa,
                    kalendarz: this.state.kalendarz,
                    godzina:this.state.godzina
                }
            )
        }
    }

    render() {

        return (
            <div>
                <Form horizontal={true}>
                    <FormGroup>
                        <Col xs={12} md={3} lg={4}>
                            <ControlLabel>Wybierz trasę <span className={'req'}>*</span></ControlLabel>
                            <TopSelect onChange={this.onChangeTrasa} value={this.state.trasa}
                                       options={this.props.trasy} valueKey={'idTr'} labelKey={'nazTr'}
                                       valueRenderer={this.optionRenderer} optionRenderer={this.optionRenderer}
                            />
                        </Col>
                        <Col xs={12} md={3} lg={2}>
                            <ControlLabel>Wybierz kalendarz</ControlLabel>
                            <TopSelect onChange={this.onChnageKalendarz} value={this.state.kalendarz}
                                       options={this.props.kalendarze} valueKey={'idRk'} labelKey={'nazRk'}
                            />
                        </Col>
                        <Col xs={12} md={3} lg={2}>
                            <ControlLabel>Filtruj od godziny</ControlLabel>
                            <FormControl type={'time'} onChange={this.onChangeGodzina}/>
                        </Col>
                        <Col xs={12} md={3} lg={2}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonAction iconType={'fa fa-search'} text={'Wyszukaj'} onClick={this.onClickSzukaj} btnSize={'medium'}/>
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <ValidatorMessages messages={this.state.validatorMessages}/>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/definicjeGodzinStartowychjDlaTrasy/components/DefinicjaGodzinyStartowejForm.js